import React, {useContext, useEffect, useState} from "react";
import PagedList from "../common/PagedList";
import axios from "../common/axios";
import {Checkbox} from "antd";
import Button from "../common/Button";
import {BrandContext} from "../common/BrandContext";
import {UserContext} from "../common/UserContext";
import AddEditClassDialog from "../schoolClasses/AddEditClassDialog";
import CircularLoader from "../common/CircularLoader";
import {ContentContext} from "../common/ContentContext";

const AllClasses = props => {
    const {updateActiveClass, callback} = props;
    const {user, updateUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const [classes, setClasses] = useState([]);
    const [addClass, setAddClass] = useState(false);
    const [listLoading, setListLoading] = useState(true);
    const {contentLoading, setContentLoading} = useContext(ContentContext);

    const columns = [
        {title: 'Class name', dataIndex: 'className', key: 'className'},
        {title: 'Class Key', dataIndex: 'classKey', key: 'classKey'},
        {title: 'Students', dataIndex: 'students', key: 'students'},
        {title: 'Teachers', dataIndex: 'teachers', key: 'teachers'},
        {title: 'School Year', dataIndex: 'schoolYear', key: 'schoolYear'},
        {title: 'Total Usage (h:mm:s)', dataIndex: 'totalUsage', key: 'totalUsage', ellipsis: true},
    ]
    if (!brandConfig.hideClassShowSolutions) columns.push({title: 'Show Answers / Suggested Responses', dataIndex: 'responses', key: 'responses', ellipsis: true});
    if (!brandConfig.hideClassShowWorkedSolutions) columns.push({title: 'Show Worked Solutions', dataIndex: 'solutions', key: 'solutions', ellipsis: true});
    if (brandConfig.showClassCalculatorOptions) {
        columns.push({title: 'Show Casio ClassPad', dataIndex: 'casio', key: 'casio', ellipsis: true});
        columns.push({title: 'Show TI-Nspire', dataIndex: 'ti', key: 'ti', ellipsis: true});
    }
    // Marking
    if (!user.disableEditClasses) columns.push({title: 'My Class', dataIndex: 'editClass', key: 'editClass'});

    function loadClasses() {
        setListLoading(true);
        axios.get('/web/ui/myClasses/viewSchoolClasses')
            .then(response => {
                setClasses(response.data.map(clazz => {
                    return clazz
                }));
            }).finally(() => {
                setListLoading(false);
            });
    }

    function updateClass(classId) {
        if(!classId) {
            return;
        }

        if(contentLoading) {
            return;
        }

        setContentLoading(true)
        axios.post('/web/ui/myClasses/updateTeacherClass', classId,{headers: {'Content-Type': 'application/json'}})
            .then(response => {
                if (response.data) {
                    setClasses(classes.map(clazz => (clazz.classId === response.data.classId ? response.data : clazz)))
                }
            }).finally(() => {
                setContentLoading(false);
            });
    }

    useEffect(() => {
        loadClasses();
        if (callback && typeof callback === 'function') callback();
    }, []);

    useEffect(() => {
        const userClasses = classes.filter(clazz => clazz.userInClass);
        user.classes = userClasses;
        updateUser(user);
    }, [classes]);

    const dataSource = classes.map(clazz => {
        let newRow = {
            key: clazz.classId,
            className: <a onClick={() => updateActiveClass(clazz)}>{clazz.className}</a>,
            classKey: clazz.classCode,
            students: clazz.totalStudents,
            teachers: clazz.totalTeachers,
            schoolYear: clazz.calendarYear,
            totalUsage: clazz.totalStudentUsage
        }
        if (!brandConfig.hideClassShowSolutions) newRow.responses = <>{clazz.showSolutions ? "Yes" : "No"}</>
        if (!brandConfig.hideClassShowWorkedSolutions) newRow.solutions = <>{clazz.showWorkedSolutions ? "Yes" : "No"}</>
        if (brandConfig.showClassCalculatorOptions) {
            newRow.casio = <>{clazz.showCalculatorCasio ? "Yes" : "No"}</>
            newRow.ti = <>{clazz.showCalculatorTi ? "Yes" : "No"}</>
        }
        if (!user.disableEditClasses) newRow.editClass = <Checkbox
            disabled={contentLoading}
            className='flexCentre'
            checked={clazz.userInClass}
            onChange={event => updateClass(clazz.classId)}
        ><span className="ch-accessibility-label">select my class</span></Checkbox>
        return newRow;
    });

    if(listLoading) {
        return <CircularLoader/>;
    }

    return (
        <>
            <p className="padding--rm">You will be able to assign Assessments and tasks, see reports and send messages to the classes you select</p>
            <Button className="margin-t--l" onClick={() => setAddClass(true)}>Add</Button>
            <PagedList className="margin-t--l" columns={columns} dataSource={dataSource} loading={listLoading} size={"small"} pagination={false} />
            <Button className="margin-t--l" onClick={() => setAddClass(true)}>Add</Button>
            <AddEditClassDialog open={addClass} setClose={() => setAddClass(false)} callback={() => loadClasses()} />
        </>
    )
}

export default AllClasses;